export const VIRTUAL_PAGE_EVENT = 'virtualPage'
export const STATES_ERROR = 'ERROR'
export const STATES_VALID = 'VALID'
export const STATES_INACTIVE = 'INACTIVE'
export const STATES_BLACKLIST = 'BLACKLIST'
export const EVENT_ACTION_KO = 'ko_form'
export const EVENT_GA = 'eventga'
export const EMAIL_ERROR = 'email_Please enter a valid E-Mail address'
